module.exports = __webpack_public_path__ + "static/media/uniamc.310bef0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/uniamc.png
// module id = 414
// module chunks = 0